import React, { useState } from "react";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SwipeableViews from 'react-swipeable-views';
import "./Testimonials.css"
// import background from '../../images/navbar_bg.png'
import { Grid } from "@mui/material";
import { autoPlay } from 'react-swipeable-views-utils';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// import Box from '@mui/core/Box';
import PropTypes from 'prop-types';
import ShowMoreText from "react-show-more-text";
import ReactReadMoreReadLess from "react-read-more-read-less";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        width: 700,
    },
}));

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        'aria-controls': `nav-tabpanel-${index}`,
    };
}

function Testimonials() {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'));

    //card
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);

    };


    //stepper

    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);

    };
    // for text and video tab
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [tab, setTab] = useState('inText');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>

            <Box sx={{ width: "100%" }} className="learner-container">

                {/* individual card */}
                <Stack spacing={0} sx={{ width: "100%", position: "relative" }}>

                    <div className="testimonial-wrap">
                        <div className="testimonial-innerContainer">
                            <h2 className="testimonials-header">Testimonials</h2>
                            <div className="border-gradient horizontal-underline only-top"></div>
                            <div className={classes.root}>
                                {/* <AppBar position="static" sx={{marginLeft:"20px"}}> */}
                                <Box sx={{ display: "content" }}>
                                    <Tabs className="testimonial-tabs"
                                        variant="fullWidth"
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="nav tabs example"

                                    >
                                        <Tab label="In Text" onClick={() => { setTab('inText'); setActiveStep(0) }} {...a11yProps(0)} />
                                        <Tab label="In Videos" onClick={() => { setTab('inVideos'); setActiveStep(0) }} {...a11yProps(1)} />

                                    </Tabs>
                                </Box>
                                <div className={value == 0 ? "down-arrow-inText" : "down-arrow-inVideo"}></div>
                                {/* </AppBar> */}
                            </div>
                        </div>

                        {tab === 'inVideos' ? (
                            <div className="testimonials-inVideos">
                                <AutoPlaySwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={activeStep}
                                    enableMouseEvents
                                    onChangeIndex={handleStepChange}
                                    interval={12000}
                                >
                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src=""
                                                            title="title for this video"
                                                            frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src=""
                                                            title="title for this video"
                                                            frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src=""
                                                            title="title for this video"
                                                            frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src=""
                                                            title="title for this video"
                                                            frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src="" frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >
                                            <Card variant="outlined" sx={{
                                                position: "relative",
                                                overflow: "initial",
                                                display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px"
                                            }} >
                                                <Stack direction="column" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                    <div className="testimonials__card__content__div">
                                                        <iframe className="testimonials__card__content__iframe"
                                                            src=""
                                                            title="title for this video"
                                                            frameborder="0">
                                                        </iframe>
                                                    </div>
                                                    <Stack direction="row" spacing={1} sx={{
                                                        width: "93%",
                                                        marginLeft: "6rem",
                                                        paddingBottom: "0.5rem"
                                                    }}>
                                                        <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                        <Box>
                                                            <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Lorem Ipsum
                                                            </Typography>
                                                            <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Spanish A1</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Stack>

                                            </Card>

                                        </Grid>

                                    </Grid>

                                </AutoPlaySwipeableViews>
                                <MobileStepper
                                    variant="dots"
                                    steps={2}
                                    position="static"
                                    activeStep={activeStep}
                                    sx={{ flexGrow: 1, background: "transparent !important", backgroundColor: "transparent !important", alignSelf: "center", marginLeft: "auto !important", marginRight: "auto !important", alignItems: "center" }}
                                    nextButton={
                                        <Button sx={{ position: isSmallScreen ? "static" : "absolute", top: isSmallScreen ? "165px !important" : "264px !important", right: isSmallScreen ? "0px" : isLargeScreen ? "1px" : "8px" }} onClick={handleNext} disabled={activeStep === 1}>
                                            <img src={activeStep == 1 ? "images/homePage/Testimonials/right_arrow.png" : "images/homePage/Testimonials/arrow_right_high.png"} style={{ width: "60%" }}></img>

                                        </Button>

                                    }
                                    backButton={
                                        <Button sx={{ position: isSmallScreen ? "static" : "absolute", top: isSmallScreen ? "165px !important" : "264px !important", left: "1px" }} onClick={handleBack} disabled={activeStep === 0}>
                                            <img src={activeStep === 0 ? "images/homePage/Testimonials/arrow_left.png" : "images/homePage/Testimonials/left_arrow_high.png"} style={{ width: "60%" }}></img>

                                        </Button>

                                    }
                                />
                            </div>
                        ) :
                            <div className="testimonials-inText">
                                <AutoPlaySwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={activeStep}
                                    enableMouseEvents
                                    onChangeIndex={handleStepChange}
                                    interval={5000}
                                >
                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            Exercises / activities we do helps us to involve more in the sessions. Clear explanations, clarifying doubts was really nice.

                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Vadapalli Jayalakshmi
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian A1</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            Trainer is excellent. Her pace is very apt for our learning and she repeats the topics in case of any questions from the team. Very helpful and she makes it easy for us to understand with many examples and exercises.

                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Maheswari Subbiah
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Spanish A1</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            It is helping me to learn new language. Approach is thorough and technical. No short cuts.
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Nilesh Amrujkar
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German A1</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "35px" }}>

                                        <Grid item xs={4}  >
                                            {/* Item-1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack spacing={2}>


                                                        <Stack direction="row" spacing={2} sx={{ paddingTop: expanded ? 2 : 0, paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                                                            <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                            </img>
                                                            <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                                So far the training is going well. I like the trainer and the way the trainer is teaching the language and the audience are very vocal in the batch.
                                                            </Typography>

                                                        </Stack>
                                                    </Stack>
                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Naresh Kumar</Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French A1</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>



                                        </Grid>


                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack spacing={2}>


                                                        <Stack direction="row" spacing={2} sx={{ paddingTop: expanded ? 2 : 0, paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                                                            <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                            </img>
                                                            <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                                This Japanese language class gives me a guidance to study JLPT N1 level, as well as it is a forum to discuss about Japanese language.
                                                            </Typography>

                                                        </Stack>



                                                    </Stack>
                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Deepika K V</Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Japanese N1</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>


                                        </Grid>

                                        {/* item 3  */}
                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack spacing={2}>


                                                        <Stack direction="row" spacing={2} sx={{ paddingTop: expanded ? 2 : 0, paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                                                            <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                            </img>
                                                            <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                                The class is very interactive, and he revises all the lessons from the previous class through exercises, so it's easy to learn and remember, really happy with the class and his teaching.
                                                            </Typography>

                                                        </Stack>



                                                    </Stack>
                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Ritesh Ranjan</Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        {/* <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack spacing={2}>


                                                        <Stack direction="row" spacing={2} sx={{ paddingTop: expanded ? 2 : 0, paddingLeft: 2, paddingRight: 2, paddingBottom: 2 }}>
                                                            <img className="quote-image" src="images/DFA/asset1.png" >
                                                            </img>
                                                            <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                                I am new to Accenture and had started doing DLF within the first month of joining. I believe it’s a very well structured and thoughtful program designed for individuals to get used to the technology, tools, terminology and Accenture way of working. I found the trainings very useful, and it helped me adapt and learn terminology, applications, contract management etc. via simple and knowledgeable modules.
                                                            </Typography>
                                                        </Stack>


                                                        <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ marginTop: "0px !important" }}>
                                                            <CardContent sx={{ paddingLeft: "60px !important" }}>
                                                                <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                                    I believe that it touches all the bases on all important knowledge areas which we use in our day to day delivery to the clients in Accenture.</Typography>
                                                            </CardContent>

                                                        </Collapse>
                                                        <ExpandMore
                                                            expand={expanded}
                                                            onClick={handleExpandClick}
                                                            aria-expanded={expanded}
                                                            aria-label="show more"

                                                            sx={{ alignSelf: "flex-end", background: "white !important", borderRadius: "0% !important", fontSize: isLargeScreen ? "10px" : "14px", border: "0px !important", position: "absolute", bottom: expanded ? "5px" : "0px", color: "#3E17A8" }}
                                                        >
                                                            {expanded ? "Read Less" : "Read More"}
                                                        </ExpandMore>
                                                    </Stack>
                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="images/DFA/arunima.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Arunima Yadaav</Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#420469 !important" }}>Senior Manager</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>



                                        </Grid> */}


                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            Sanjana's way of teaching is really great, easy to understand and great way of learning. With the amount of exercises, we get to learn and speak better.
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Sanjana Pathak
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            Overall all feedback is positive. She explains the topic clearly. Whenever we asked any question then she explained correctly. She explains examples and helped to do exercise  in book.

                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Jeevitha Varatharaj
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            Shruti Sharma is an awesome trainer who teaches us in a very effective and friendly manner, she never fails to entertain us while teaching. Also, she' punctual, workaholic, never leaves anything half.
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Shruti Sharma
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            The accent of this trainer is great. Also has patience.
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Sandip Gosh
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            She is a very good trainer. Helps a lot in understanding the pronounciation of the words. Activity based learning helps to understand easier and better

                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Prachi Mittal
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>French</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I am writing this to express my profound gratitude to the Accenture European Language Programme & to our wonderful instructor Shruti Rawat. This programme has made it easier for me, to learn this language.
                                                                Shruti’s teaching method is very thorough, she has a very well-planned curriculum that involves lessons, activities, quizzes & at time, music too! The pace at which the course is scheduled gives us enough time to revise the lessons. Shruti is extremely helpful when it comes to solving our doubts & queries. She is very patient & understands everyone’s concerns & queries.
                                                                I am now able to pick up words spoken in Spanish shows & songs and understand the context, without having to look at subtitles! Even though we are at a very basic level, the grammar & vocabulary that has been taught enables me to do this.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Anshul Joshi
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Spanish</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            The language learning journey has been very good. We had been adding new words to our vocabulary on every session and have pretty good idea of sentence formation by now. We can now understand some basic conversations and participate too.
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Mohit Tiwari
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Spanish</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I am really enjoying the language journey. I can think of countless opportunities that I can venture into by learning a widely spoken language such as Spanish. Trainer has really helped us understand the concepts from ground 0 of Spanish and has put in ample amount of effort to make us comfortable with the core of language, which will help us make stronger foundations when we get deeper into the language journey.
                                                                I am using these language skills in my project to converse with the onshore COEs and trying to leave a good impression and strengthen their bonds with our organization. Moreover, It has also helped me in certain personal side projects as well and enhancing my CV. I am really grateful to Accenture and the whole L&TT team for the efforts that they have put into facilitating these courses. It is really going to help us face the everchanging markets scenario and also It has been an engaging activity which refreshes our mind and broadens our horizons.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Shreyansh Sinha
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Spanish</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Although at the beginning, in December, it seemed that we had a long way to go for course completion, here we are! With an exponential increase in our understanding and usage of Spanish language! All thanks to you!!!
                                                                I really liked how our sessions were organized and conducted. It had a methodology and we went through quite some exercises which were very helpful. What I found the most helpful and fun were the mock exam sessions as well as the gamification class we had. It really helped me build confidence and realize where I needed to focus in terms of different modules (LSRW).
                                                                All in all, I thoroughly enjoyed our Spanish lessons and having you as our instructor! Hope to see you soon in the A2 sessions!
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Priyanka Dantuluri
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Spanish</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Hi Pankaj, I had luckily got your A1 crash course link from my colleague and the tips and tricks explained by you was very useful for me to clear the exam.
                                                                Your explanation is crisp and to point which made me feel easy to grab the concept.
                                                                Main thing to mention about the method of how the class notes are being given from your side is super useful for revising after the classes.
                                                                During Hören exercises, you are sharing the subtitles of the videos which is also giving us a lot of benefit in quickly understanding the conversations.
                                                                Thanks a lot for your teaching, Pankaj. Looking forward for your batched for upcoming A2 crash course and B1 preps.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Bhuvana Muthu
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Hi Pankaj, Hope this email finds you well!
                                                                I am writing this note to express my gratitude and heartfelt thanks for helping me and others and guide us towards learning about German.
                                                                You have been very helpful and giving very useful tips and directing us towards achieving our learning skill.
                                                                I never had any prior exposure to German Language before this course and this is the first time since my school days that I have attempted to learn a foreign language.
                                                                I had lots of apprehension about my learning capabilities prior to joining this course, but with your proper and apt guidance, I have at least completed the A1 German course now 😊
                                                                I appreciate your guidance much and I am much obliged to have this opportunity to learn from you.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Uma Bhattacharyya
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Hi Vartika,This mail is to appreciate your efforts for conducting the German course in such a fantastic way.
                                                                I really doubted by abilities to learn any new language while I was enrolling but the way you carried out the sessions and exercises I felt confident to participate and interact in daily classes. Unfortunately I was not able to attend the final exam since my last working day with Accenture is just couple of days away, but the knowledge and experience I gained will definitely be helpful in future when I will plan to take my A1 exam.
                                                                Thank you for this great initiative, I hope it continues and help more people acquire additional language skills.

                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Saurabh Gokul Kale
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Hi Shreya,
                                                                I’m sure this put a big smile on other participants as it did for me, thanks for your kind words. It was indeed an exciting experience to be able to compose a piece in a new language and it would not have been possible without your guidance and wonderful way of teaching, thank you for all the amazing sessions 😊. Even the fest was great and looking forward to participate in further events.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Aakriti Yashwardhan
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Hello Shreya,
                                                                I would like to share my brief feedback on the Traning session we are presently undergoing.
                                                                Foremost thanks to the Accenture team for organizing such an incredible learning experience. A new language at this stage of life is a sheer zeal of excitement with immense exposure.
                                                                I have been working with a German Client for the past 11 years where seldom in calls, I hear them interacting in German, when I had to keep a deaf ear but now, the scene has changed, I am able to decipher what they mean to say 😊
                                                                (atleast figure out the direction of the communication).
                                                                I am in the beginning stage of this learning journey and moving forward I am sure to become conversant with the language and even speak with my Clients in German 😊Immense thanks to Accenture for this golden opportunity.
                                                                Lastly, I would do a grave injustice if I miss out to quote the contribution of Shreya, our trainer.
                                                                She has been the North star in the sky whom we follow each day at class. Her approach in making the language interesting, involving us in communication, resolving innumerable queries has made this journey even more beautiful.
                                                                We are lucky as a Batch to have her guide us in this path. Kudos to Shreya, best wishes !
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Joydeep Mukherjee
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>German</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Your session was very helpful for me. You made Italian language very simple and enjoyable for me through your teaching. You were available for us all the time whenever we stuck or have any queries. You inspired all of us to learn Italian and nominate for A2. I enjoyed every session. Thank you for your help and support throughout the training.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Diksha Balaso Jadhav
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                It was really helpful with the sessions to learn on new language. Thanks for keeping patience and making us learn better the pace of the course and content presentation was good. Great initiate from the organization to engage resources to learn new ways.	The pace of the course and content presentation was good. Great initiate from the organization to engage resources to learn new ways.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Rama Krishna Jakkula
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Grazie Shiv for all your efforts in helping me kick start Italian A1 learning journey, really appreciate your patience, going exta mile in making learning interesting(learning videos, insights on cuisine, culture, short stories videos, popular songs and much more).
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Archana Krishnamurthy
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                You are very good trainer to teach Italian language. You did your best to cover and explained very good all topics in detail. Even, you helped us to revise all topics before assessments.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Simranjit Singh
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I would like to express my appreciation for Sagar(our Italian class teacher). He is exceptional—knowledgeable, punctual, and engaging.He fosters inclusive discussions and encourages active participation.
                                                                I appreciate the personalized approach and encouragement to practice speaking. Thanks to the trainer, my Italian proficiency has noticeably improved, and I look forward to each session.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Vidhyadhari Anbalagan
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                Brilliantly done Italian team Enjoyed the event ! Little Italy is going to get lots of business after today's event.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Archana Krishnamurthy
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                You are very good trainer to teach Italian language. You did your best to cover and explained very good all topics in detail. Even, you helped us to revise all topics before assessments.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Simranjit Singh
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I really enjoyed learning Italian with Prajakta .She was very patient, supportive, and her friendly personality that makes the classes fun and engaging. She made the lessons interesting and interactive, using a variety of activities and videos etc. . She also gave us useful feedback and tips to improve my pronunciation, grammar, and vocabulary.
                                                                I have learned so much from her and I look forward learning more from her.
                                                                She became a friend come teacher in this journey😊
                                                                She also gave us useful feedback and tips to improve my pronunciation, grammar, and vocabulary.
                                                                I have learned so much from her and I look forward learning more from her.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Nikita Sharma
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I really appreciate the efforts that she puts in while teaching our batch, be it suggesting videos and books, to going through various activities such as asking us to read out small texts in Italian and interacting in Italian with us. We also watch interactive Italian videos on YouTube at times to enhance our grammatical and conversational skills. She really goes one step ahead in encouraging us to upskill by suggesting one on one FAQ discussions in case of any queries and asks for our suggestions to improve the interactions and the learnings in the class .
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Rutuja Mahesh Chaudhari
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                It was a great honor learning Italian A1 level with you. You kept the class interesting and encouraged us to work on learning. Looking forward to learn further under your guidance.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Poornima Krishnan
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                    </Grid>

                                    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2} sx={{ width: "98%", paddingBottom: "15px", paddingTop: "15px", paddingLeft: "40px" }}>

                                        <Grid item xs={4}  >
                                            {/* item1 */}
                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                I gave my CILS A1 too last week in Delhi and the experience was awesome.
                                                                I met my batchmates and we were practically revising the grammar and conversing in Italian before the exam. We met other people too and they were astonished that we 5 from Accenture
                                                                were able to understand what one natural italian was speaking to a B1 level candidate. I'd like to thank Anjalika for teaching us to always trust in ourselves even though we make mistakes.
                                                                I'll surely try to attend all the A2 Classes.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src="./images/homePage/Testimonials/avatar.png"></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Sriram Sridhar
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>

                                        {/* item2 */}

                                        <Grid item xs={4}  >

                                            <Stack spacing={2} >
                                                <Card variant="outlined" sx={{
                                                    position: "relative",
                                                    overflow: "initial",
                                                    display: "flex", justifyContent: "center", alignItems: "center", minHeight: "185px", '&:after': {
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: 0,
                                                        left: "11%",
                                                        width: 0,
                                                        height: 0,
                                                        border: "13px solid transparent",
                                                        borderTopColor: "white",
                                                        borderBottom: 0,
                                                        marginLeft: "-13px",
                                                        marginBottom: "-13px"
                                                    }
                                                }} >
                                                    <Stack direction="row" spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
                                                        <img className="quote-image" src="images/homePage/Testimonials/Quotation.png" >
                                                        </img>
                                                        <Typography sx={{ textAlign: "left", fontSize: isMediumScreen ? "8px" : isLargeScreen ? "10px" : "12px" }} className="testi-content">
                                                            <ReactReadMoreReadLess
                                                                charLimit={350}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                            >
                                                                First of all, I would like to thank you Accenture for giving us this golden opportunity to learn Italian Language and thanks to Anjalika for always supporting us and help us when we have doubts, you did your 100% for helping us and give the simplest way for explanation so that we can learn easily. It was great experience. Last week I went to Delhi for CILS examination and that was an awesome experience to meet our batchmates and Italian people and talk with them. From that experience I learnt lots of things. Don't know what the result come but I will move further for continuing my Italian Language journey and will move forward for A2 level.
                                                            </ReactReadMoreReadLess>
                                                        </Typography>

                                                    </Stack>

                                                </Card>


                                                <Stack direction="row" spacing={1}>
                                                    <img className="people-icon" src={process.env.PUBLIC_URL + "/images/homePage/Testimonials/avatar.png"}></img>
                                                    <Box>
                                                        <Typography className="leader-name" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#fff !important" }}>Surbhi Sahu
                                                        </Typography>
                                                        <Typography className="leader-designation" sx={{ fontSize: isLargeScreen ? "10px" : "14px", textAlign: "left", color: "#b87cf7 !important" }}>Italian</Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>

                                        </Grid>


                                        {/* item3 */}


                                    </Grid>

                                </AutoPlaySwipeableViews>
                                <MobileStepper
                                    variant="dots"
                                    steps={11}
                                    position="static"
                                    activeStep={activeStep}
                                    sx={{ maxWidth: 400, flexGrow: 1, background: "transparent !important", backgroundColor: "transparent !important", alignSelf: "center" }}
                                    nextButton={
                                        <Button sx={{ position: isSmallScreen ? "static" : "absolute", top: "237px", right: isSmallScreen ? "0px" : isLargeScreen ? "1px" : "8px" }} onClick={handleNext} disabled={activeStep === 10}>
                                            <img src={activeStep == 10 ? "images/homePage/Testimonials/right_arrow.png" : "images/homePage/Testimonials/arrow_right_high.png"} style={{ width: "60%" }}></img>

                                        </Button>

                                    }
                                    backButton={
                                        <Button sx={{ position: isSmallScreen ? "static" : "absolute", top: "237px", left: "1px" }} onClick={handleBack} disabled={activeStep === 0}>
                                            <img src={activeStep === 0 ? "images/homePage/Testimonials/arrow_left.png" : "images/homePage/Testimonials/left_arrow_high.png"} style={{ width: "60%" }}></img>

                                        </Button>

                                    }
                                />
                            </div>


                        }

                    </div>


                </Stack>
            </Box>

        </>

    );
}

export default Testimonials;
